// extracted by mini-css-extract-plugin
export default {"customLink":"ZcZrMYzLmOzVLTfJDyWh","customLinkFirst":"u3B8f6Yn9MybnhH4tObw"};